import React from 'react'
import PropTypes from 'prop-types'

import { languageController } from '../../../../controllers/language/languageController'

function Input({
  type,
  name,
  id,
  value,
  label,
  errorMessage,
  isRequired,
  onChange,
  onBlur,
  showOptional=false,
  extraClass,
  ...otherProps
}) {
  return (
    <div className={`mz-form-item mz-form-item--${type} ${extraClass ? extraClass : ''}`}>
      <input
        type={type}
        name={name}
        className='mz-form-item__textfield'
        id={id}
        value={value}
        required={isRequired}
        onChange={onChange}
        onBlur={onBlur}
        {...otherProps}
      />
      {
        label && (
          <label
            className={`mz-form-item__label ${value.length ? 'shrink' : ''}`}
            htmlFor={id}
          >
            {label}{(isRequired && label) && (<span className="mz-form-item__required-star">*</span>)}
          </label>
        )
      }
      {showOptional &&
        <div className="label text--grey">{languageController.getFormCopy('label', 'optional')}</div>
      }
      {errorMessage && (
        <div className="mz-form-item__error-message">{errorMessage}</div>
      )}
    </div>
  )
}

Input.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  isRequired: PropTypes.bool,
  otherProps: PropTypes.object,
}

export default Input